import React from 'react';
import MeetingLobbyBackgroundEffectsButton from './MeetingLobbyBackgroundEffectsButton';
import MeetingLobbyCameraButton from './MeetingLobbyCameraButton';
import MeetingLobbyMicButton from './MeetingLobbyMicButton';

/**
 * Mic, camera and background effects, sitting over the lobby's own video rather
 * than in a row beneath it. They belong to the preview, so they live on it —
 * which also leaves the row below free for the name and the join button.
 *
 * Each control owns its own state and reads its own slice, so changing one does
 * not disturb the others; they share only the surface, in
 * MeetingLobbyDeviceButton.
 *
 * The device-settings cog is a sibling in the same row, kept in
 * MeetingLobbyVideo because it needs that component's popover anchor.
 */
const MeetingLobbyDeviceControls = () => (
    <>
        <MeetingLobbyMicButton />
        <MeetingLobbyCameraButton />
        <MeetingLobbyBackgroundEffectsButton />
    </>
);

export default MeetingLobbyDeviceControls;
